<!-- Initiatl version received from Ahmed -->
<template>
  <div class="main-container" @click="emit('clickEmpty')">
    <div class="items-field">
      <ul class="items">
        <li @click.stop class="item" v-for="(item, i) in items" :key="i">
          <RouterLink v-if="item.link" target="_blank" :to="item.link">
            {{ item.name }}
          </RouterLink>
          <template v-else>
            {{ item.name }}
          </template>
          <span @click.stop="removeItem(i)" class="remove-item">x</span>
        </li>
      </ul>
    </div>
    <div class="add-item-container">
      <!-- Slot to provide item addition logic -->
      <slot v-bind="{ addItem, addItems }"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch } from "vue";
import { RouterLink } from "vue-router";

export interface Props {
  modelValue: any,
  width?: string,
}

const props = withDefaults(defineProps<Props>(), {
  width: "40ch"
});


const emit = defineEmits(['update:modelValue', 'clickEmpty'])

const items = reactive<any[]>(props.modelValue);
watch(items, () => {
  emit('update:modelValue', items);
})

function addItem(item: any) {
  if (item && !isItemExist(item)) {
    items.push(item);
  }
}

function addItems(items: any[]) {
  items.forEach(item => addItem(item));
}

function removeItem(index: number) {
  items.splice(index, 1);
}

function isItemExist(item: any) {
  return items.some(existingItem => existingItem.id == item.id);;
}
</script>

<style lang="scss" scoped>
.main-container {
  display: flex;
  gap: 0.19rem;
  flex-direction: column;
  align-items: flex-end;
}

.add-item-container {
  /* padding-top: 0.375rem; */
}

.items-field {
  color: #666666;
  border: 1px solid #abadb3;
  height: fit-content;
  padding: 2px 2px 1px 2px;
  width: v-bind('props.width');
  min-height: 2.8rem;
  outline: none;
  user-select: none;
}

.items {
  margin: 5px 0;
}

.item {
  color: #fff;
  border-radius: 0.375rem;
  /* background: #1c69d4; */
  background: #72a8dd;
  border-radius: 0.375rem;
  border: 0;
  margin: 0 4px 2px 0;
  padding: 4px;
  display: inline-block;
}

.item > a {
  color: #fff;
  padding: 0;
  text-decoration: none;
}

.remove-item {
  color: #ffffff82;
  cursor: pointer;
  font-weight: bold;
  padding: 2px;
}
</style>